(function() {
    'use strict';

    angular
        .module('ccsTrApp')
        .controller('ControllerDetailController', ControllerDetailController);

    ControllerDetailController.$inject = ['$scope','$rootScope','$stateParams','previousState','entity','Controller','ControllerCustomService','$uibModal','DateUtils','MiscService',
                                        'CommentCustomService','AttachmentCustomService','ControllerPaymentCustomService'];

    function ControllerDetailController($scope, $rootScope, $stateParams, previousState, entity, Controller, ControllerCustomService, $uibModal, DateUtils, MiscService,
                                        CommentCustomService, AttachmentCustomService, ControllerPaymentCustomService) {
        var vm = this;

        vm.controller = entity;
        vm.previousState = previousState;
        vm.updateController = updateController;
        vm.setScale = setScale;
        vm.nl2br = MiscService.nl2br;
        vm.getOrDash = getOrDash;
        vm.addControllerPayment = addControllerPayment;
        vm.updateControllerPayment = updateControllerPayment;
        vm.deleteControllerPayment = deleteControllerPayment;
        vm.createTab = createTab;
        vm.addControllerComment = addControllerComment;
        vm.updateControllerComment = updateControllerComment;
        vm.deleteControllerComment = deleteControllerComment;
        vm.addControllerPaymentComment = addControllerPaymentComment;
        vm.updateControllerPaymentComment = updateControllerPaymentComment;
        vm.deleteControllerPaymentComment = deleteControllerPaymentComment;
        vm.addControllerPaymentAttachment = addControllerPaymentAttachment;
        vm.downloadControllerPaymentAttachment = downloadControllerPaymentAttachment;
        vm.deleteControllerPaymentAttachment = deleteControllerPaymentAttachment;
        vm.paymentsTotal = 0;
        vm.controllerPayments = [];
        vm.comments = [];

        returnControllerPayments();
        returnControllerComments();

        function updateController() {
            var modalInstance = $uibModal.open({
                templateUrl: 'app/entities/controller/controller-dialog.html',
                controller: 'ControllerDialogController',
                controllerAs: 'vm',
                size: 'lg',
                resolve: {
                    entity: function() {
                        return vm.controller;
                    },
                    translatePartialLoader: ['$translate','$translatePartialLoader', function($translate, $translatePartialLoader) {
                        $translatePartialLoader.addPart('controller');
                        $translatePartialLoader.addPart('currencyType');
                        $translatePartialLoader.addPart('global');
                        return $translate.refresh();
                    }]
                }
            });
            modalInstance.result.then(function(data) {
                vm.controller = data;
                returnControllerPayments();
                returnControllerComments();
            });
        }

        function addControllerPayment() {
            var modalInstance = $uibModal.open({
                templateUrl: 'app/entities/controller-payment/controller-payment-dialog.html',
                controller: 'ControllerPaymentDialogController',
                controllerAs: 'vm',
                size: 'lg',
                resolve: {
                    entity: function() {
                        return {
                            id: null,
                            createdOn: new Date(),
                            createdBy: 'admin',
                            modifiedOn: new Date(),
                            modifiedBy: 'admin',
                            paymentLabel: '',
                            paymentDate: new Date(),
                            amount: 0,
                            currency: vm.controller.currency,
                            amountDisplay: vm.controller.currency + " " + 0
                        }
                    },
                    controller: function() {
                        return {
                            id: vm.controller.id
                        }
                    },
                    translatePartialLoader: ['$translate','$translatePartialLoader', function($translate, $translatePartialLoader) {
                        $translatePartialLoader.addPart('controller');
                        $translatePartialLoader.addPart('currencyType');
                        $translatePartialLoader.addPart('global');
                        return $translate.refresh();
                    }]
                }
            });
            modalInstance.result.then(function() {
                returnControllerPayments();
                updateControllerBalance()
            });
        }

        function updateControllerPayment(cp) {
            var modalInstance = $uibModal.open({
                templateUrl: 'app/entities/controller-payment/controller-payment-dialog.html',
                controller: 'ControllerPaymentDialogController',
                controllerAs: 'vm',
                size: 'lg',
                resolve: {
                    entity: function() {
                        return cp;
                    },
                    controller: function() {
                        return {
                            id: vm.controller.id
                        }
                    },
                    translatePartialLoader: ['$translate','$translatePartialLoader', function($translate, $translatePartialLoader) {
                        $translatePartialLoader.addPart('controller');
                        $translatePartialLoader.addPart('currencyType');
                        $translatePartialLoader.addPart('global');
                        return $translate.refresh();
                    }]
                }
            });
            modalInstance.result.then(function() {
                returnControllerPayments();
                updateControllerBalance();
            });
        }

        function deleteControllerPayment(cp) {
            var modalInstance = $uibModal.open({
                templateUrl: 'app/entities/controller-payment/controller-payment-delete-dialog.html',
                controller: 'ControllerPaymentDeleteDialogController',
                controllerAs: 'vm',
                size: 'md',
                resolve: {
                    entity: function() {
                        return cp;
                    },
                    translatePartialLoader: ['$translate','$translatePartialLoader', function($translate, $translatePartialLoader) {
                        $translatePartialLoader.addPart('controller');
                        $translatePartialLoader.addPart('global');
                        return $translate.refresh();
                    }]
                }
            });
            modalInstance.result.then(function() {
                returnControllerPayments();
                updateControllerBalance();
            });
        }

        function returnControllerPayments() {
            vm.controllerPayments = [];
            ControllerPaymentCustomService.findAllControllerPaymentsByControllerId(vm.controller.id).then(function(data) {
                vm.controllerPayments = data.data;
                getPaymentTotal();
                getPaymentAttachments();
                getPaymentComments();
            }, function(error) {
                vm.controllerPayments = [];
                ToastrService.error("Failed to get Payments", "Error");
            });
        }

        function updateControllerBalance() {
            ControllerCustomService.returnControllerBalance(vm.controller.id).then(function(data) {
                vm.controller.balance = data.data;
            }, function(error) {
                ToastrService.error("Failed to get current balance of Controller Payment","Error");
            });
        }

        function getPaymentTotal() {
            var sum = 0;
            if(vm.controllerPayments.length > 0) {
                angular.forEach(vm.controllerPayments, function(value, key) {
                    sum += value.amount;
                })
            }
            vm.paymentsTotal = sum;
        }

        function getPaymentAttachments() {
            if(vm.controllerPayments.length > 0) {
                for(var i=0; i < vm.controllerPayments.length; i++) {
                    getPaymentAttachmentsByIdAndIndex(vm.controllerPayments[i].id, i);
                }
            }
        }

        function getPaymentAttachmentsByIdAndIndex(id, index) {
            vm.controllerPayments[index].attachments = [];
            AttachmentCustomService.returnAttachmentsByControllerPayment(id).then(function(data) {
                vm.controllerPayments[index].attachments = data.data;
            }, function(error) {
                ToastrService.error("Failed to get Attachments for payment with id: " + id,"Error");
            });
        }

        function getPaymentComments() {
            if(vm.controllerPayments.length > 0) {
                for(var i=0; i < vm.controllerPayments.length; i++) {
                    getPaymentCommentsByIdAndIndex(vm.controllerPayments[i].id, i);
                }
            }
        }

        function getPaymentCommentsByIdAndIndex(id, index) {
            vm.controllerPayments[index].comments = [];
            CommentCustomService.returnCommentsByControllerPayment(id).then(function(data) {
                vm.controllerPayments[index].comments = data.data;
            }, function(error) {
                ToastrService.error("Failed to get Comments for payment with id: " + id,"Error");
            });
        }

        function returnControllerComments() {
            vm.comments = [];
            CommentCustomService.returnCommentsByController(vm.controller.id).then(function(data) {
                vm.comments = data.data;
            }, function(error) {
                vm.comments = [];
                ToastrService.error("Failed to get Comments", "Error");
            });
        }

        function addControllerComment() {
            var modalInstance = $uibModal.open({
                templateUrl: 'app/entities/comment/comment-dialog.html',
                controller: 'CommentDialogController',
                controllerAs: 'vm',
                backdrop: 'static',
                size: 'md',
                resolve: {
                    entity: function() {
                        return {
                            id: null,
                            createdOn: new Date(),
                            createdBy: 'admin',
                            modifiedOn: new Date(),
                            modifiedBy: 'admin',
                            comment: '',
                            active: true
                        }
                    },
                    shipmentEntity: function() {
                        return null;
                    },
                    contractEntity: function() {
                        return null;
                    },
                    lotEntity: function() {
                        return null;
                    },
                    invoiceEntity: function() {
                        return null;
                    },
                    requiredDocumentEntity: function() {
                        return null;
                    },
                    controllerEntity: function() {
                        return {
                            id: vm.controller.id
                        }
                    },
                    controllerPaymentEntity: function() {
                        return null;
                    },
                    translatePartialLoader: ['$translate','$translatePartialLoader', function($translate, $translatePartialLoader) {
                        $translatePartialLoader.addPart('comment');
                        $translatePartialLoader.addPart('global');
                        return $translate.refresh();
                    }]
                }
            });
            modalInstance.result.then(function() {
                returnControllerComments();
            });
        }

        function updateControllerComment(comment) {
            var modalInstance = $uibModal.open({
                templateUrl: 'app/entities/comment/comment-dialog.html',
                controller: 'CommentDialogController',
                controllerAs: 'vm',
                backdrop: 'static',
                size: 'md',
                resolve: {
                    entity: function() {
                        return comment;
                    },
                    shipmentEntity: function() {
                        return null;
                    },
                    contractEntity: function() {
                        return null;
                    },
                    lotEntity: function() {
                        return null;
                    },
                    invoiceEntity: function() {
                        return null;
                    },
                    requiredDocumentEntity: function() {
                        return null;
                    },
                    controllerEntity: function() {
                        return {
                            id: vm.controller.id
                        }
                    },
                    controllerPaymentEntity: function() {
                        return null;
                    },
                    translatePartialLoader: ['$translate','$translatePartialLoader', function($translate, $translatePartialLoader) {
                        $translatePartialLoader.addPart('comment');
                        $translatePartialLoader.addPart('global');
                        return $translate.refresh();
                    }]
                }
            });
            modalInstance.result.then(function() {
                returnControllerComments();
            });
        }

        function deleteControllerComment(index) {
            var modalInstance = $uibModal.open({
                templateUrl: 'app/entities/comment/comment-delete-dialog.html',
                controller: 'CommentDeleteController',
                controllerAs: 'vm',
                backdrop: 'static',
                size: 'sm',
                resolve: {
                    entity: function() {
                        return vm.comments[index];
                    },
                    shipmentEntity: function() {
                        return null;
                    },
                    contractEntity: function() {
                        return null;
                    },
                    lotEntity: function() {
                        return null;
                    },
                    invoiceEntity: function() {
                        return null;
                    },
                    requiredDocumentEntity: function() {
                        return null;
                    },
                    controllerEntity: function() {
                        return {
                            id: vm.controller.id
                        }
                    },
                    controllerPaymentEntity: function() {
                        return null;
                    },
                    translatePartialLoader: ['$translate','$translatePartialLoader', function($translate, $translatePartialLoader) {
                        $translatePartialLoader.addPart('comment');
                        $translatePartialLoader.addPart('global');
                        return $translate.refresh();
                    }]
                }
            });
            modalInstance.result.then(function() {
                returnControllerComments();
            });
        }

        function addControllerPaymentComment(id, index) {
            var modalInstance = $uibModal.open({
                templateUrl: 'app/entities/comment/comment-dialog.html',
                controller: 'CommentDialogController',
                controllerAs: 'vm',
                backdrop: 'static',
                size: 'md',
                resolve: {
                    entity: function() {
                        return {
                            id: null,
                            createdOn: new Date(),
                            createdBy: 'admin',
                            modifiedOn: new Date(),
                            modifiedBy: 'admin',
                            comment: '',
                            active: true
                        }
                    },
                    shipmentEntity: function() {
                        return null;
                    },
                    contractEntity: function() {
                        return null;
                    },
                    lotEntity: function() {
                        return null;
                    },
                    invoiceEntity: function() {
                        return null;
                    },
                    requiredDocumentEntity: function() {
                        return null;
                    },
                    controllerEntity: function() {
                        return null;
                    },
                    controllerPaymentEntity: function() {
                        return {
                            id: vm.controllerPayments[index].id
                        }
                    },
                    translatePartialLoader: ['$translate','$translatePartialLoader', function($translate, $translatePartialLoader) {
                        $translatePartialLoader.addPart('comment');
                        $translatePartialLoader.addPart('global');
                        return $translate.refresh();
                    }]
                }
            });
            modalInstance.result.then(function() {
                getPaymentCommentsByIdAndIndex(id, index);
            });
        }

        function updateControllerPaymentComment(comment, id, index) {
            var modalInstance = $uibModal.open({
                templateUrl: 'app/entities/comment/comment-dialog.html',
                controller: 'CommentDialogController',
                controllerAs: 'vm',
                backdrop: 'static',
                size: 'md',
                resolve: {
                    entity: function() {
                        return comment;
                    },
                    shipmentEntity: function() {
                        return null;
                    },
                    contractEntity: function() {
                        return null;
                    },
                    lotEntity: function() {
                        return null;
                    },
                    invoiceEntity: function() {
                        return null;
                    },
                    requiredDocumentEntity: function() {
                        return null;
                    },
                    controllerEntity: function() {
                        return null;
                    },
                    controllerPaymentEntity: function() {
                        return {
                            id: id
                        }
                    },
                    translatePartialLoader: ['$translate','$translatePartialLoader', function($translate, $translatePartialLoader) {
                        $translatePartialLoader.addPart('comment');
                        $translatePartialLoader.addPart('global');
                        return $translate.refresh();
                    }]
                }
            });
            modalInstance.result.then(function() {
                getPaymentCommentsByIdAndIndex(id, index);
            });
        }

        function deleteControllerPaymentComment(comment, id, index) {
            var modalInstance = $uibModal.open({
                templateUrl: 'app/entities/comment/comment-delete-dialog.html',
                controller: 'CommentDeleteController',
                controllerAs: 'vm',
                backdrop: 'static',
                size: 'sm',
                resolve: {
                    entity: function() {
                        return comment;
                    },
                    shipmentEntity: function() {
                        return null;
                    },
                    contractEntity: function() {
                        return null;
                    },
                    lotEntity: function() {
                        return null;
                    },
                    invoiceEntity: function() {
                        return null;
                    },
                    requiredDocumentEntity: function() {
                        return null;
                    },
                    controllerEntity: function() {
                        return null;
                    },
                    controllerPaymentEntity: function() {
                        return {
                            id: id
                        }
                    },
                    translatePartialLoader: ['$translate','$translatePartialLoader', function($translate, $translatePartialLoader) {
                        $translatePartialLoader.addPart('comment');
                        $translatePartialLoader.addPart('global');
                        return $translate.refresh();
                    }]
                }
            });
            modalInstance.result.then(function() {
                getPaymentCommentsByIdAndIndex(id, index);
            });
        }

        function addControllerPaymentAttachment(id, index) {
            var modalInstance = $uibModal.open({
                templateUrl: 'app/entities/attachment/attachment-dialog.html',
                controller: 'AttachmentDialogController',
                controllerAs: 'vm',
                backdrop: 'static',
                size: 'sm',
                resolve: {
                    type: function() {
                        return 'controller-payment'
                    },
                    objectId: function() {
                        return id
                    },
                    translatePartialLoader: ['$translate','$translatePartialLoader', function($translate, $translatePartialLoader) {
                        $translatePartialLoader.addPart('attachment');
                        $translatePartialLoader.addPart('global');
                        return $translate.refresh();
                    }]
                }
            });
            modalInstance.result.then(function() {
                getPaymentAttachmentsByIdAndIndex(id, index);
            });
        }

        function downloadControllerPaymentAttachment(attachment) {
            AttachmentCustomService.downloadAttachment(attachment.id).then(function(data, status, headers, config) {
                var file = new Blob([data.data], {type:'application/octect-stream'});
                saveAs(file, attachment.fileName);
            }, function(error) {
                if(error.status !== 404) {
                    ToastrService.error("Cannot Download Attachment", "Error");
                }
            });
        }

        function deleteControllerPaymentAttachment(attachment, cpId, index) {
            var modalInstance = $uibModal.open({
                templateUrl: 'app/entities/attachment/modal/attachment-delete-modal.html',
                controller: 'AttachmentDeleteModalController',
                controllerAs: 'vm',
                backdrop: 'static',
                size: 'md',
                resolve: {
                    entity: function() {
                        return attachment;
                    },
                    translatePartialLoader: ['$translate','$translatePartialLoader',function($translate, $translatePartialLoader) {
                        $translatePartialLoader.addPart('attachment');
                        $translatePartialLoader.addPart('global');
                        return $translate.refresh();
                    }]
                }
            });
            modalInstance.result.then(function() {
                getPaymentAttachmentsByIdAndIndex(cpId, index);
            });
        }

        var unsubscribe = $rootScope.$on('ccsTrApp:controllerUpdate', function(event, result) {
            vm.controller = result;
        });
        $scope.$on('$destroy',unsubscribe);

        function getOrDash(val) {
            return (val && val !== null) ? val : '-';
        }

        function createTab(data) {
            $scope.$emit('handleEmit', data);
        }

        function setScale(value, scale) {
            return parseFloat(value).toFixed(scale);
        }
    }
})();
